<div class="header-language" *ngIf="isVisible">
  <a
    [attr.data-test]="'i18n_link-lang-' + i"
    *ngFor="let lang of getAvailableLangs(); let i = index"
    href="javascript:void(0);"
    [ngClass]="{ active: activeLanguage() == lang }"
    (click)="setActiveLanguage(lang)"
    >{{ lang }}</a
  >
</div>
